import React from 'react'
import OAMSider from "../../oam-sider"
import {
  message,
  Button,
  Col,
  ConfigProvider,
  Layout,
  Pagination,
  Popconfirm,
  Row,
  Statistic,
  Table,
  Tooltip,
  Select,
  Input,
} from 'antd'

import CommitDetail from "../../components/commit-detail/CommitDetail";



export interface Props{

}

const OAMCommitDetail:React.FC<Props> = (props) => {
  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f5f6f8;' }}>
      <OAMSider keys={'commit_record'} openKeys={['']}></OAMSider>
      <CommitDetail mode={"oam"} />
    </Layout>
  )
}

export default OAMCommitDetail